module.exports = __webpack_public_path__ + "assets/img/news (46).0916c9b2.png";